import React from "react";
import { useNavigate } from "react-router-dom";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid p-4">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
          <div className="card shadow-sm">
            <div className="card-body p-5">
              <div className="d-flex align-items-center mb-4">
                <button
                  className="btn btn-outline-secondary me-3"
                  onClick={() => navigate(-1)}
                  style={{ borderRadius: "8px" }}
                >
                  ← Back
                </button>
                <h1 className="h2 mb-0">Privacy Policy</h1>
              </div>
              
              <div className="text-muted mb-4">
                <small>Last updated: {new Date().toLocaleDateString()}</small>
              </div>

              <div className="privacy-content">
                <section className="mb-4">
                  <h3 className="h4 mb-3">Information We Collect</h3>
                  <p className="mb-3">
                    We collect information you provide directly to us, such as when you create an account, 
                    use our services, or contact us for support. This may include:
                  </p>
                  <ul className="mb-3">
                    <li>Personal information (name, email address, phone number)</li>
                    <li>Account credentials and preferences</li>
                    <li>Usage data and analytics</li>
                    <li>Communication records</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">How We Use Your Information</h3>
                  <p className="mb-3">
                    We use the information we collect to:
                  </p>
                  <ul className="mb-3">
                    <li>Provide, maintain, and improve our services</li>
                    <li>Process transactions and send related information</li>
                    <li>Send technical notices and support messages</li>
                    <li>Respond to your comments and questions</li>
                    <li>Monitor and analyze trends and usage</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Information Sharing</h3>
                  <p className="mb-3">
                    We do not sell, trade, or otherwise transfer your personal information to third parties 
                    without your consent, except as described in this policy. We may share your information:
                  </p>
                  <ul className="mb-3">
                    <li>With service providers who assist us in operating our platform</li>
                    <li>To comply with legal obligations</li>
                    <li>To protect our rights and prevent fraud</li>
                    <li>In connection with a business transfer or merger</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Data Security</h3>
                  <p className="mb-3">
                    We implement appropriate security measures to protect your personal information against 
                    unauthorized access, alteration, disclosure, or destruction. However, no method of 
                    transmission over the internet is 100% secure.
                  </p>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Your Rights</h3>
                  <p className="mb-3">
                    You have the right to:
                  </p>
                  <ul className="mb-3">
                    <li>Access and update your personal information</li>
                    <li>Request deletion of your data</li>
                    <li>Opt-out of certain communications</li>
                    <li>Request data portability</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Cookies and Tracking</h3>
                  <p className="mb-3">
                    We use cookies and similar tracking technologies to enhance your experience, 
                    analyze usage patterns, and personalize content. You can control cookie settings 
                    through your browser preferences.
                  </p>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Contact Us</h3>
                  <p className="mb-3">
                    If you have any questions about this Privacy Policy, please contact us at:
                  </p>
                  <div className="bg-light p-3 rounded">
                    <p className="mb-1"><strong>Email:</strong> privacy@buddyx.com</p>
                    <p className="mb-0"><strong>Address:</strong> [Your Company Address]</p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
